import React from "react";
import Hero from "../Components/SearchScreenComps/Hero";

const SearchScreen = () => {

    return (
    <div>
        <Hero />
    </div>
    )
}
export default SearchScreen;
